module.exports = __webpack_public_path__ + "static/media/3.764dd34e.png";